import axios from 'axios';
import API_BASE_URL from './config';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data on 401
      localStorage.removeItem('token');
      // Redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Helper method to get file preview URL with authentication
api.getFilePreviewUrl = (executionId, fileId) => {
  const token = localStorage.getItem('token');
  const baseUrl = `${API_BASE_URL}/flows/execution/${executionId}/files/${fileId}/preview`;
  return token ? `${baseUrl}?token=${token}` : baseUrl;
};

export default api; 